/* UnboxDeals 2026 — small JS for the redesign (slideshow + carousel arrows + mobile search) */
(function () {
  'use strict';

  function initSlideshow(root) {
    var slides = root.querySelectorAll('.ud26-hero-slide');
    var dots   = root.querySelectorAll('[data-ud26-dots] button');
     var current = 0;
    var mobileMedia = window.matchMedia('(max-width: 768px)');

    function getSlideRatio(slide) {
      if (!slide) return 3.047619;

      var desktopRatio = parseFloat(slide.style.getPropertyValue('--ud26-hero-desktop-ratio')) || 3.047619;
      var mobileRatio = parseFloat(slide.style.getPropertyValue('--ud26-hero-mobile-ratio')) || desktopRatio;

      return mobileMedia.matches ? mobileRatio : desktopRatio;
    }

    function updateAspectRatio() {
      root.style.setProperty('--ud26-hero-active-ratio', String(getSlideRatio(slides[current])));
    }

    slides.forEach(function (slide, index) {
      slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
    });
 updateAspectRatio();

    if (slides.length < 2) {
      window.addEventListener('resize', updateAspectRatio);
      return;
    }
    function show(i) {
      i = ((i % slides.length) + slides.length) % slides.length;
      if (i === current) return;

      slides[current].classList.remove('is-active');
      slides[i].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      slides[i].setAttribute('aria-hidden', 'false');
      if (dots[current]) dots[current].classList.remove('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
      current = i;
      updateAspectRatio();
    }
    dots.forEach(function (b, i) {
      b.addEventListener('click', function () { show(i); reset(); });
    });

    var timer = null;
    var speed = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    function start() {
      if (timer) clearInterval(timer);
      if (speed > 0) timer = setInterval(function () { show(current + 1); }, speed);
    }
    function reset() { if (timer) { clearInterval(timer); timer = null; } start(); }
     window.addEventListener('resize', updateAspectRatio);
    start();
  }

  function initCarouselArrows(root) {
    var list = root.querySelector('[data-ud26-pc-list]');
    var prev = root.querySelector('[data-ud26-prev]');
    var next = root.querySelector('[data-ud26-next]');
    if (!list || !prev || !next) return;
    var step = function () {
      var first = list.querySelector('.ud26-card');
      if (!first) return 200;
      return first.getBoundingClientRect().width + 14;
    };
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left:  step(), behavior: 'smooth' }); });
  }

  function setMobileMenuState(open) {
    var drawer = document.querySelector('[data-ud26-mob-menu-drawer]');
    var overlay = document.querySelector('.ud26-mob-menu-overlay');
    if (!drawer || !overlay) return;

    if (open) {
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ud26-mob-menu-open');
      return;
    }

    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ud26-mob-menu-open');
    window.setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 260);
  }

  function stripHtml(value) {
    var temp = document.createElement('div');
    temp.innerHTML = value == null ? '' : String(value);
    return (temp.textContent || temp.innerText || '').trim();
  }

  function formatMoneyValue(cents) {
    if (cents == null || cents === '') return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return stripHtml(window.Shopify.formatMoney(cents, window.moneyFormat || '${{amount}}'))
        .replace(/([.,]00)(?!\d)/, '')
        .trim();
    }

    var amount = Number(cents) / 100;
    return isNaN(amount) ? '' : amount.toFixed(2).replace(/\.00$/, '');
  }

  function hasMeaningfulContent(node) {
    if (!node) return false;
    if (node.nodeType === 3) return !!node.textContent.trim();
    return !!(node.textContent || '').trim() || !!node.querySelector('img, ul, ol, table');
  }

  function initPdpDescription(root) {
    var source = root.querySelector('[data-ud26-pdp-description-source]');
    var summary = root.querySelector('[data-ud26-pdp-summary]');
    var features = root.querySelector('[data-ud26-pdp-features]');
    if (!source || !summary || !features) return;

    var temp = document.createElement('div');
    temp.innerHTML = source.innerHTML.trim();
    if (!temp.innerHTML.trim()) return;

    var firstParagraph = temp.querySelector('p');
    if (firstParagraph) {
      summary.innerHTML = firstParagraph.outerHTML;
      firstParagraph.remove();
    } else {
      var firstMeaningful = Array.prototype.find.call(temp.childNodes, hasMeaningfulContent);
      if (firstMeaningful) {
        if (firstMeaningful.nodeType === 3) {
          var p = document.createElement('p');
          p.textContent = firstMeaningful.textContent.trim();
          summary.appendChild(p);
          firstMeaningful.textContent = '';
        } else {
          summary.innerHTML = firstMeaningful.outerHTML;
          firstMeaningful.remove();
        }
      }
    }

    if (temp.innerHTML.trim()) {
      features.innerHTML = temp.innerHTML;
    }

    if (!summary.innerHTML.trim()) {
      summary.innerHTML = source.innerHTML;
    }

    if (!features.innerHTML.trim()) {
      features.innerHTML = summary.innerHTML;
    }
  }

  function setActiveThumb(root, imageId) {
    if (!imageId) return;
    root.querySelectorAll('.ud26-pdp-thumb').forEach(function (thumb) {
      thumb.classList.toggle('is-active', String(thumb.getAttribute('data-image-id')) === String(imageId));
    });
  }

  function getVisibleImageId(root) {
    var visible = root.querySelector('.ud26-pdp-photo:not(.hide)');
    return visible ? visible.getAttribute('data-image-id') : null;
  }

  function getProductData(root) {
    if (root._ud26ProductData) return root._ud26ProductData;
    var sectionId = root.getAttribute('data-section-id');
    var json = sectionId ? document.getElementById('ProductJson-' + sectionId) : null;
    if (!json) return null;
    try {
      root._ud26ProductData = JSON.parse(json.textContent);
    } catch (err) {
      root._ud26ProductData = null;
    }
    return root._ud26ProductData;
  }

  function getCurrentVariant(root) {
    var sectionId = root.getAttribute('data-section-id');
    var select = sectionId ? document.getElementById('productSelect-' + sectionId) : null;
    var productData = getProductData(root);
    if (!select || !productData || !productData.variants) return null;

    var selectedId = parseInt(select.value, 10);
    return productData.variants.find(function (variant) {
      return variant.id === selectedId;
    }) || null;
  }

  function updatePdpVariantUi(root) {
    var variant = getCurrentVariant(root);
    if (!variant) return;

    var priceCurrent = root.querySelector('[data-ud26-pdp-price-current]');
    var priceCompare = root.querySelector('[data-ud26-pdp-price-compare]');
    var saveBadge = root.querySelector('[data-ud26-pdp-save]');
    var barcode = root.querySelector('.variant-barcode');
    var stock = root.querySelector('[data-ud26-pdp-stock]');
    var stockText = root.querySelector('[data-ud26-pdp-stock-text]');

    if (priceCurrent) {
      priceCurrent.textContent = formatMoneyValue(variant.price);
    }

    if (priceCompare) {
      if (variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoneyValue(variant.compare_at_price);
        priceCompare.classList.remove('is-hidden');
      } else {
        priceCompare.classList.add('is-hidden');
      }
    }

    if (saveBadge) {
      if (variant.compare_at_price > variant.price) {
        var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        saveBadge.textContent = 'SAVE ' + pct + '%';
        saveBadge.classList.remove('is-hidden');
      } else {
        saveBadge.classList.add('is-hidden');
      }
    }

    if (barcode) {
      barcode.textContent = variant.barcode || 'N/A';
    }

    if (stock && stockText) {
      if (variant.available) {
        stock.classList.remove('is-out');
        if (variant.inventory_management && variant.inventory_quantity > 0) {
          stockText.textContent = variant.inventory_quantity + ' In Stock';
        } else {
          stockText.textContent = 'In Stock';
        }
      } else {
        stock.classList.add('is-out');
        stockText.textContent = 'Out of Stock';
      }
    }

    if (variant.featured_image && variant.featured_image.id) {
      setActiveThumb(root, variant.featured_image.id);
    } else {
      setActiveThumb(root, getVisibleImageId(root));
    }
  }

  function syncShippingAccordion(root) {
    var shipping = root.querySelector('[data-ud26-shipping-accordion]');
    if (!shipping) return;
    if (window.matchMedia('(max-width: 768px)').matches) {
      shipping.removeAttribute('open');
    } else {
      shipping.setAttribute('open', '');
    }
  }

  function initPdp(root) {
    initPdpDescription(root);
    syncShippingAccordion(root);
    updatePdpVariantUi(root);

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('.product-photo-thumb');
      if (thumb) {
        setActiveThumb(root, thumb.getAttribute('data-image-id'));
      }

      var shareTrigger = event.target.closest('[data-ud26-share-trigger]');
      if (shareTrigger) {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: window.location.href
          }).catch(function () {});
        } else {
          window.open('https://wa.me/?text=' + encodeURIComponent(window.location.href), '_blank', 'noopener');
        }
      }
    });

    root.addEventListener('change', function (event) {
      if (!event.target.matches('select')) return;
      setTimeout(function () {
        updatePdpVariantUi(root);
      }, 0);
    });

    window.addEventListener('resize', function () {
      syncShippingAccordion(root);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-ud26-slides]').forEach(initSlideshow);
    document.querySelectorAll('.ud26-pc').forEach(initCarouselArrows);
    document.querySelectorAll('[data-ud26-pdp-root]').forEach(function (pdpRoot) {
      var sectionRoot = pdpRoot.closest('[data-section-type="product-template"]');
      if (sectionRoot) initPdp(sectionRoot);
    });

    // Mobile menu toggle for the UD26 drawer
    var burger = document.querySelector('[data-ud26-mob-menu]');
    var menuDrawer = document.querySelector('[data-ud26-mob-menu-drawer]');
    if (burger) {
      burger.addEventListener('click', function () {
        setMobileMenuState(!(menuDrawer && menuDrawer.classList.contains('is-open')));
      });
    }

    document.querySelectorAll('[data-ud26-mob-menu-close]').forEach(function (closeTarget) {
      closeTarget.addEventListener('click', function () {
        setMobileMenuState(false);
      });
    });

    document.querySelectorAll('[data-ud26-mob-subtoggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('li');
        var submenu = item ? item.querySelector('.ud26-mob-submenu') : null;
        if (!item || !submenu) return;

        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
        submenu.hidden = isOpen;
      });
    });

    if (menuDrawer) {
      menuDrawer.querySelectorAll('.ud26-mob-submenu').forEach(function (submenu) {
        submenu.hidden = true;
      });
      menuDrawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) {
          setMobileMenuState(false);
        }
      });
    }

    // Mobile search reveal — shows the inline mobile search form
    var searchBtn = document.querySelector('[data-ud26-mob-search]');
    var searchForm = document.querySelector('[data-ud26-mob-search-form]');
    if (searchBtn && searchForm) {
      searchBtn.addEventListener('click', function () {
        var hidden = searchForm.hasAttribute('hidden');
        if (hidden) {
          searchForm.removeAttribute('hidden');
          var input = searchForm.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          searchForm.setAttribute('hidden', '');
        }
      });
    }
  });
})();
